import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'settings';

// Action Types
export const types = {
  GET_SALES_BY_KIOSK: createAsyncTypes(`${KEY}/GET_SALES_BY_KIOSK`),
  SET_CONFIGURATION_ID: `${KEY}/SET_CONFIGURATION_ID`,
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_SALES_BY_KIOSK: `${KEY}/RESET_SALES_BY_KIOSK`
};

export interface KioskSales {
  externalId: string;
  amexTransactionsCount: number;
  amexTransactionsAmount: number;
  nonAmexTransactionsCount: number;
  nonAmexTransactionsAmount: number;
}

export interface SettingsState {
  readonly configurationId: string;
  readonly salesByKiosk: KioskSales[] | null;
  readonly action: {
    readonly pending: boolean;
    readonly success: boolean;
    readonly error: string | null;
  };
}

export interface GetSalesByKioskRequest {
  type: typeof types.GET_SALES_BY_KIOSK.REQUEST;
  payload: {
    startDate: string;
    endDate: string;
  };
}

export interface GetSalesByKioskPending {
  type: typeof types.GET_SALES_BY_KIOSK.PENDING;
  payload: boolean;
}

export interface GetSalesByKioskSuccess {
  type: typeof types.GET_SALES_BY_KIOSK.SUCCESS;
  payload: KioskSales[];
}

export interface GetSalesByKioskError {
  type: typeof types.GET_SALES_BY_KIOSK.ERROR;
  payload: string;
}

export interface SetConfigurationId {
  type: typeof types.SET_CONFIGURATION_ID;
  payload: string;
}

export interface ResetAction {
  type: typeof types.RESET_ACTION;
}

export interface ResetSalesByKiosk {
  type: typeof types.RESET_SALES_BY_KIOSK;
}

export type SettingsActionTypes = GetSalesByKioskRequest | SetConfigurationId | ResetAction | ResetSalesByKiosk;
